module.exports = __webpack_public_path__ + "static/media/22829408_1629538077121377_2105713494658658132_o.ab5fb3a0.jpg";